import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';
import DistributionChart from 'src/javascripts/components/charts/DistributionChart';
import TrendRatings from 'src/javascripts/components/charts/TrendRatings';

export default class Carbon {

  constructor() {}

  render() {

	  // If an index page 
	  let page = $('body').attr('data-page');
	  if (page.indexOf('Index') !== 0) {
    	ResearchFiltering();
	  }

    // Distribution chart
    let hasDist = $('.distributionChart').length !== 0
    let c3NotLoaded = typeof $('.distributionChart').data('c3-chart') === 'undefined';
    if ((hasDist) && (c3NotLoaded)) {
      $('.distributionChart').each(function() {
        let $el = $(this);
        let $chart = new DistributionChart($el);
        $.when( $chart.getData() )
         .then( data => $chart.render(data) );
      })
    }

    // Trend chart
    let hasTrend = $('.trendRatingsChart').length !== 0
    let c3NotLoadedTrend = typeof $('.trendRatingsChart').data('c3-chart') === 'undefined';
    if ((hasTrend) && (c3NotLoadedTrend)) {
      $('.trendRatingsChart').each(function() {
        let $el = $(this);
        let $chart = new TrendRatings($el);
        $.when( $chart.getData() )
         .then( data => $chart.render(data) );
      })
    }


 }

}